/**
 * SignOutButton Component
 * Renders a sign-out link/button that clears tokens and redirects to Cognito logout
 * Only shown when user is authenticated
 */

import { useAuthContext } from '../../contexts/AuthContext';

/**
 * SignOutButton component
 * Displays a sign-out link that clears authentication tokens and logs out
 * Only visible when user is authenticated
 * 
 * @returns Sign-out button component or null if not authenticated
 */
export function SignOutButton() {
  const { isAuthenticated, signOut, isLoading } = useAuthContext();

  // Only show when authenticated and not loading
  if (!isAuthenticated || isLoading) {
    return null;
  }

  return (
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault();
        signOut();
      }}
      aria-label="Sign out"
      style={{
        color: 'var(--color-fg)',
        textDecoration: 'none',
        transition: 'color 0.2s'
      }}
    >
      Sign Out
    </a>
  );
}
